/* global analytics */
import { onLCP, onINP, onCLS, onTTFB, onFCP } from 'web-vitals'
import type { Metric } from 'web-vitals'

// Field Core Web Vitals → Segment. Runs on the main thread (web-vitals relies on
// real-time PerformanceObserver) — only the analytics.track call is relayed to the
// worker via Partytown's forward list, so this must NOT be loaded through Partytown.
const send = (metric: Metric) => {
  if (typeof analytics === 'undefined') return

  analytics.track('Web Vitals', {
    metric: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    navigation_type: metric.navigationType,
    path: window.location.pathname,
  })
}

const reportWebVitals = () => {
  onLCP(send)
  onINP(send)
  onCLS(send)
  onTTFB(send)
  onFCP(send)
}

export default reportWebVitals
